import { render, staticRenderFns } from "./ebc-rule-list.vue?vue&type=template&id=66c40af4&scoped=true&"
import script from "./ebc-rule-list.vue?vue&type=script&lang=js&"
export * from "./ebc-rule-list.vue?vue&type=script&lang=js&"
import style0 from "./ebc-rule-list.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ebc-rule-list.vue?vue&type=style&index=1&id=66c40af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c40af4",
  null
  
)

export default component.exports